export enum EmployeeBenefitCardStatusEnum {
  all = 'all',
  withBenefitCard = 'with-benefit-card',
  withoutBenefitCard = 'without-benefit-card',
}